var _rect, _rect2, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
const SvgComponentChainPlaceholder = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "asset/component chain image"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "frame",
    width: 44,
    height: 44,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1491_130081",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 44,
    height: 44
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "image frame",
    width: 44,
    height: 44,
    rx: 4,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1491_130081)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "empty state"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtract",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 22C38 30.8366 30.8366 38 22 38C13.1634 38 6 30.8366 6 22C6 13.1634 13.1634 6 22 6C30.8366 6 38 13.1634 38 22ZM29.7662 17H26.7653C26.0991 17 25.6876 17.7268 26.0303 18.2981L27.9869 21.559C28.1497 21.8304 28.1497 22.1696 27.9869 22.441L26.0304 25.7019C25.6876 26.2732 26.0991 27 26.7653 27H29.7662C30.0672 27 30.3462 26.842 30.5012 26.5839L32.9869 22.441C33.1497 22.1696 33.1497 21.8304 32.9869 21.559L30.5012 17.4161C30.3462 17.158 30.0672 17 29.7662 17ZM12.7951 17.3015L13.1045 16.9984C13.2224 16.943 13.348 16.902 13.4815 16.8752H16.0917C15.8913 15.8218 16.2909 15.0703 17.2905 14.6207C18.3255 14.3634 19.0989 14.6981 19.6107 15.6248C19.7848 16.0302 19.817 16.4471 19.7074 16.8752H20.9342C20.9556 16.8718 20.9776 16.87 21 16.87H21.5292C21.9627 16.87 22.3661 17.0916 22.5986 17.4574L25.0538 21.3203C25.3174 21.7351 25.3174 22.2649 25.0538 22.6797L22.5986 26.5425C22.4171 26.828 22.1316 27.0257 21.8089 27.0987C21.7831 27.1103 21.7558 27.1192 21.7272 27.1249H21.6425C21.605 27.1283 21.5672 27.13 21.5292 27.13H21C20.978 27.13 20.9564 27.1282 20.9354 27.1249H19.7074C19.9077 28.1783 19.5081 28.9298 18.5086 29.3795C17.6655 29.6199 16.963 29.4052 16.4011 28.7353C16.051 28.2433 15.9479 27.7064 16.0917 27.1249H13.4815C13.348 27.0982 13.2224 27.0571 13.1045 27.0018L12.7951 26.6986C12.7386 26.5831 12.6967 26.4599 12.6694 26.3292V23.4305C12.7625 22.9676 13.0461 22.7719 13.5202 22.8431C14.0221 23.0956 14.4668 23.0199 14.8543 22.6158C15.1636 22.1555 15.1378 21.7135 14.7769 21.2896C14.388 20.9602 13.969 20.916 13.5202 21.157C13.0461 21.2283 12.7625 21.0325 12.6694 20.5696V17.6709C12.6967 17.5402 12.7386 17.417 12.7951 17.3015Z",
    fill: "#F4F5FA"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponentChainPlaceholder);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/component-chain-placeholder.debd617336dec6ade683a8b16b9ac1f6.svg";